import { format } from "url"
// eslint-disable-next-line no-restricted-imports
import Router, { NextRouter, useRouter as useNextRouter } from "next/router"

import { routeChangeEmitter } from "@/lib/embedded/route-change-emitter"
import { isEmbedded } from "@/lib/is-embedded"

function withEmbeddedNavigation(router: NextRouter): NextRouter {
  return new Proxy(router, {
    get(target, prop, receiver) {
      if (isEmbedded()) {
        if (prop === "push") {
          return new Proxy(target[prop], {
            apply(fn, thisArg, args: Parameters<NextRouter["push"]>) {
              const [url] = args
              routeChangeEmitter.emit(
                typeof url === "string" ? url : format(url)
              )
              return Promise.resolve()
            },
          })
        }

        if (prop === "replace") {
          return new Proxy(target[prop], {
            apply(fn, thisArg, args: Parameters<NextRouter["replace"]>) {
              const [url] = args
              routeChangeEmitter.emit(
                typeof url === "string" ? url : format(url)
              )
              return Promise.resolve()
            },
          })
        }
      }
      return Reflect.get(target, prop, receiver)
    },
  })
}

export function useRouter() {
  return withEmbeddedNavigation(useNextRouter())
}

/**
 * The router for code that lives outside React. Next's singleton forwards to
 * the same mounted router the hook returns. Resolved on demand: tests that
 * mock next/router rarely provide the default export.
 */
export function getAppRouter(): NextRouter {
  return withEmbeddedNavigation(Router)
}
